import React from "react";
import "./AllClients.css";

const clients = [
  { id: 1, name: "Jehangir Hospital, Pune", logo: "/assets/clients/client1.png" },
  { id: 2, name: "Lokmanya Hospital, Pune", logo: "/assets/clients/client2.png" },
  { id: 3, name: "Noble Hospitals & Research Centre, Pune", logo: "/assets/clients/client3.png" },
  { id: 4, name: "Surya Multispeciality Hospital, Dharashiv", logo: "/assets/clients/client4.png" },
  { id: 5, name: "Sahyadri Hospitals, Pune", logo: "/assets/clients/client5.png" },
  { id: 6, name: "Fortis S L Raheja Hospital, Mumbai", logo: "/assets/clients/client6.png" },
  { id: 7, name: "Param Hospital, Virar (Dr. Kiran Dane)", logo: "/assets/clients/client7.png" },
  { id: 8, name: "Lifeline Hospital, Baramati (Dr. Sachin Ghorpade)", logo: "/assets/clients/client8.png" },
  { id: 9, name: "Shree Chaitanya IVF Centre", logo: "/assets/clients/client9.png" },
  { id: 10, name: "Pawar Multispeciality Hospital", logo: "/assets/clients/client10.png" },
  { id: 11, name: "Mohan Hospital, Sangola", logo: "/assets/clients/client11.png" },
  { id: 12, name: "Aryan Heart Care, Miraj", logo: "/assets/clients/client12.png" },
  { id: 13, name: "I Sport Medical Centre, Pune", logo: "/assets/clients/client13.png" },
  { id: 14, name: "Omkar Khalane Hospital, Pune", logo: "/assets/clients/client14.png" },
  { id: 15, name: "Excell Speciality Hospital, Pune", logo: "/assets/clients/client15.png" },
  { id: 16, name: "Mangal Hospital, Tembhurni", logo: "/assets/clients/client16.png" },
  { id: 17, name: "Sushrut Hospital, Phaltan", logo: "/assets/clients/client17.png" },
  { id: 18, name: "Singh Multispeciality Hospital, Jejuri", logo: "/assets/clients/client18.png" },
  { id: 19, name: "SaiGanesh Orthopedic Hospital, Kolhapur", logo: "/assets/clients/client19.png" },
  { id: 20, name: "Ambajogai IVF Centre, Beed", logo: "/assets/clients/client20.png" },
  { id: 21, name: "MGM Hospital, Mumbai", logo: "/assets/clients/client21.png" },
  { id: 22, name: "Saraswati Hospital, Baramati", logo: "/assets/clients/client22.png" },
  { id: 23, name: "Zen Multispeciality Hospital, Mumbai", logo: "/assets/clients/client23.png" },
  { id: 24, name: "Lamkhade Hospital, Pune", logo: "/assets/clients/client24.png" },
  { id: 25, name: "Zamindar Eye Centre, Bangalore", logo: "/assets/clients/client25.png" },
  { id: 26, name: "Vision Hospital, Goa", logo: "/assets/clients/client26.png" },
  { id: 27, name: "Jabalpur Hospital, MP", logo: "/assets/clients/client27.png" },
  { id: 28, name: "Dr. Ravi Patil Institutions, Belgaum", logo: "/assets/clients/client28.png" },
  { id: 29, name: "Sandhu Hospital, Punjab", logo: "/assets/clients/client30.png" },
  { id: 30, name: "Ramakrishna Hospital, Bangalore", logo: "/assets/clients/client31.png" },
  { id: 31, name: "ASG Eye Hospitals, Jamshedpur", logo: "/assets/clients/client32.png" },
];

/* 📍 Cities for SEO + Map */
const serviceCities = [
  "Pune", "Mumbai", "Baramati", "Miraj", "Kolhapur",
  "Goa", "Belgaum", "Bangalore", "Jabalpur", "Amritsar"
];

function AllClients() {
  return (
    <section className="allclients-page">

      {/* HEADER */}
      <div className="allclients-header">
        <h1>Modular OT Projects & Hospital Clients Across India</h1>
        <p>
          Wellness Electro Medical Systems (WEMS) has successfully delivered
          modular operation theatre projects across India including ICU, NICU,
          PICU and laminar airflow systems for hospitals.
        </p>
      </div>

      {/* GRID */}
      <div className="allclients-grid">
        {clients.map((client) => (
          <div key={client.id} className="allclients-card">
            <div className="logo-wrap">
              <img src={client.logo} alt={client.name} loading="lazy" />
            </div>
            <h3>{client.name}</h3>
          </div>
        ))}
      </div>

      {/* ✅ PAN INDIA SEO SECTION */}
      <div className="seo-section">
        <h2>Pan India Modular OT Installation Services</h2>

        <p>
          We provide <strong>modular OT design, manufacturing and installation</strong> 
          services across India. Our team specializes in NABH-compliant operation 
          theatres with advanced air filtration and laminar airflow systems.
        </p>

        <p>
          Our modular OT solutions are trusted by hospitals in major cities like 
          Pune, Mumbai, Bangalore, Kolhapur, Goa and across multiple states.
        </p>

        {/* KEYWORDS LIST */}
        <ul className="seo-list">
          <li>Modular OT Manufacturer in India</li>
          <li>Operation Theatre Setup Services</li>
          <li>Laminar Airflow OT Systems</li>
          <li>Hospital OT Turnkey Projects</li>
          <li>ICU, NICU & PICU Setup</li>
        </ul>
      </div>

      {/* ✅ MAP SECTION */}
      <div className="map-section">
        <h2>Our Presence Across India</h2>

        <p>We have successfully completed projects in the following cities:</p>

        <div className="city-tags">
          {serviceCities.map((city, index) => (
            <span key={index}>{city}</span>
          ))}
        </div>

        {/* Google Map Embed
        <div className="map-container">
          <iframe
            title="WEMS Locations India"
            src="https://www.google.com/maps?q=India&output=embed"
            loading="lazy"
          ></iframe>
        </div> */}
      </div>

    </section>
  );
}

export default AllClients;